// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "_" + "1f7683af1184f3f98597" + ".min.js";
};